export default __webpack_public_path__ + "swg-icons.b759bd89.woff2";